import React from 'react';

interface PriceDisplayProps {
  price: number;
  originalPrice?: number | null;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: { current: 'text-base', original: 'text-[10px]' },
  md: { current: 'text-lg', original: 'text-xs' },
  lg: { current: 'text-2xl', original: 'text-sm' },
};

export const PriceDisplay: React.FC<PriceDisplayProps> = ({ price, originalPrice, size = 'md' }) => {
  const cls = sizeClasses[size];
  return (
    <div className="flex items-baseline gap-2">
      {originalPrice && (
        <span className={`line-through text-slate-500 font-semibold ${cls.original}`}>
          ${originalPrice.toLocaleString('es-ES', { maximumFractionDigits: 0 })}
        </span>
      )}
      <span className={`font-heading font-extrabold text-slate-800 ${cls.current}`}>
        ${price.toLocaleString('es-ES', { maximumFractionDigits: 0 })}
      </span>
    </div>
  );
};
